export default __webpack_public_path__ + "static/media/woman-new-mobile-2.b450c521.png";